import {Component, QueryList, ViewChildren} from '@angular/core';
import {animate, state, style, transition, trigger} from "@angular/animations";
import {environment} from "@environment";

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrl: './about.component.scss',
  animations: [
    trigger('fadeInAnimation', [
      state('in', style({opacity: 1})),
      transition(':enter', [
        style({opacity: 0}),
        animate(1600)
      ])
    ])]
})
export class AboutComponent {

  environment: any = environment;

  assetUrl: string = `${environment.assetsImagesPath}/assets/img/carousel/carousel1.png`;
  adminUrl: string = `/assets/img/about/admin_01.png`;
  introAssetUrl: string = `/assets/img/about/public_mobile.webp`;
  publicMobileModuleUrl: string = `/assets/img/about/public_mobile_transparent.webp`;
  organiserModuleUrl: string = `/assets/img/about/admin_01.png`;
  @ViewChildren('chapter') chapterDivs: QueryList<any> | undefined;

  contactManagement: string = environment.contactManagement;
  contactManagementMail: string = environment.contactManagementMail;
  contactManagementPhone: string = environment.contactManagementPhone;

  contactHelpdeskMail: string = environment.contactHelpdeskMail;

  trackChapter(index: number, chapter: number): number {
    return chapter;
  }


  scrollToChapter(chapterIndex: number) {
    if (this.chapterDivs) {
      const chapterDivsArray = this.chapterDivs.toArray();
      const chapterElement = chapterDivsArray[chapterIndex-1];
      if (chapterElement) {
        chapterElement.nativeElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  }
}
